(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7422,4421],{

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BackgroundBannerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var BackgroundBannerImage = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "fill" : _layout, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _priority = param.priority, priority = _priority === void 0 ? true : _priority, className = param.className;
    // TODO: update blue_banner.svg to not be massive and refactor this component to use <BlueBanner /> instead.
    //       Current implementation clashes with loki visual regression testing - stopping us from using this component in our stories
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: className,
        src: "/blue_banner.svg",
        layout: layout,
        objectFit: objectFit,
        alt: alt,
        priority: priority
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundBannerImage);


/***/ }),

/***/ 44421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64673);



/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/0861f9faa132466797439461b87a432016bab643/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 59771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobCard_JobCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./components/JobClientDetails/index.tsx + 1 modules
var JobClientDetails = __webpack_require__(52225);
// EXTERNAL MODULE: ./components/JobInformation/index.tsx + 4 modules
var JobInformation = __webpack_require__(73037);
// EXTERNAL MODULE: ./components/ShareContainer/index.tsx + 1 modules
var ShareContainer = __webpack_require__(35079);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./modules/JobCard/JobCard.module.scss
var JobCard_module = __webpack_require__(17184);
var JobCard_module_default = /*#__PURE__*/__webpack_require__.n(JobCard_module);
;// CONCATENATED MODULE: ./modules/JobCard/JobCard.tsx














var JobCard = function(param) {
    var data = param.data, topButtonElement = param.topButtonElement, bottomButtonElement = param.bottomButtonElement, className = param.className, _isJobSummary = param.isJobSummary, isJobSummary = _isJobSummary === void 0 ? false : _isJobSummary, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    var ref;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    var isExtraSmallScreen = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var jobNumber = data.jobNumber;
    var subspcialityOrSpeciality = data.subspeciality ? data.subspeciality : data.speciality;
    var jobDetailsPath = (0,jobListingHelper/* generateJobDetailsURL */.wZ)(data.jobNumber, data.grade, subspcialityOrSpeciality);
    var jobSharingUrl = "".concat((ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.origin).concat(jobDetailsPath);
    var newLineEncoding = "%0d%0a";
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()(className, (JobCard_module_default()).container, isHighlighted && (JobCard_module_default()).highlighted),
        "data-testid": "job-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 9,
                        sm: 6,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            "data-testid": "job-card-grade",
                            className: (JobCard_module_default()).grade,
                            children: data.grade
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        container: true,
                        justifyContent: "flex-end",
                        md: 6,
                        sm: 6,
                        xs: 3,
                        children: topButtonElement
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 5,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                prefetch: false,
                                href: jobDetailsPath,
                                as: jobDetailsPath,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (JobCard_module_default()).title,
                                    onClick: function() {
                                        track("Job Details", {
                                            "Details Origin": "Job Card",
                                            "Details Action": "Title Link",
                                            jobNumber: jobNumber
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h5",
                                        component: isJobSummary ? "h2" : "h1",
                                        "data-testid": "job-card-speciality",
                                        children: data.subspeciality ? data.subspeciality : data.speciality
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobInformation/* JobInformation */.ym, {
                                job: data
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        container: true,
                        justifyContent: "space-between",
                        xs: 12,
                        sm: 6,
                        md: 7,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobClientDetails/* default */.Z, {
                                user: user,
                                data: data
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                item: true,
                                container: true,
                                justifyContent: isExtraSmallScreen ? "space-between" : "flex-end",
                                alignItems: "flex-end",
                                className: (JobCard_module_default()).bottomContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer/* default */.Z, {
                                            jobOrArticleShare: "jobshare",
                                            id: jobNumber,
                                            className: (JobCard_module_default()).jobShare,
                                            emailTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "Who would you like ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " to send this job to?"
                                                ]
                                            }),
                                            emailSubject: "".concat((ref1 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref1 !== void 0 ? ref1 : "Medrecruit", " recommended a job for you"),
                                            emailBody: "View the job recommended for you by ".concat((ref2 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref2 !== void 0 ? ref2 : "Medrecruit", " ").concat(newLineEncoding).concat(encodeURI((0,urlHelper/* getUtmShareUrl */.En)("jobshare", jobSharingUrl, "email"))),
                                            facebookTitle: data.title,
                                            shareUrl: jobSharingUrl,
                                            shareTrackingProps: {
                                                name: "Share Job",
                                                details: {
                                                    "Share Origin": "Job Card",
                                                    jobNumber: jobNumber
                                                }
                                            },
                                            popperPlacement: isExtraSmallScreen ? "bottom-start" : "bottom-end"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        children: bottomButtonElement
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var JobCard_JobCard = (JobCard);

;// CONCATENATED MODULE: ./modules/JobCard/index.tsx



/***/ }),

/***/ 74304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ UserLoggedinContainer; },
/* harmony export */   "N": function() { return /* binding */ ContainerStyle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82898);
/* harmony import */ var _app_constants_path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96703);
/* harmony import */ var _components_BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44421);
/* harmony import */ var _modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65200);
/* harmony import */ var _modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22952);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43832);
/* harmony import */ var modules_Footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2910);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52533);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_10__);














var CookieConsentPrompt = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 1273).then(__webpack_require__.bind(__webpack_require__, 26871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26871)
            ];
        }
    }
});
var ContainerStyle;
(function(ContainerStyle) {
    ContainerStyle["BLUE_BANNER"] = "blueBanner";
    ContainerStyle["LITTLE_BLUE_BANNER"] = "littleBlueBanner";
    ContainerStyle["SMALL_BLUE_BANNER"] = "bgBannerSmallBanner";
    ContainerStyle["MEDIUM_BLUE_BANNER"] = "mediumBlueBanner";
    ContainerStyle["BACKDROP_BLUE_BANNER"] = "backdropBlueBanner";
    ContainerStyle["NO_BANNER"] = "noBanner";
    ContainerStyle["TINY_BLUE_BANNER"] = "tinyBlueBanner";
    ContainerStyle["PROFILE_BANNER_FF_DOT144"] = "profileBannerFF_DOT144";
    ContainerStyle["MEDWORLD_PROFILE"] = "medworldProfileBanner";
    ContainerStyle["DARK_BLUE_BANNER"] = "darkBlueBanner";
})(ContainerStyle || (ContainerStyle = {}));
var UserLoggedinContainer = function(param) {
    var _style = param.style, style = _style === void 0 ? ContainerStyle.BLUE_BANNER : _style, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, children = param.children, noFooterMargin = param.noFooterMargin;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref = (0,_modules_Context_useAuth0User__WEBPACK_IMPORTED_MODULE_4__/* .useAuth0User */ .a)(), user = ref.user, checkSession = ref.checkSession, isLoading = ref.isLoading;
    var getClassName = function() {
        var styleName;
        switch(style){
            case ContainerStyle.BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container);
                break;
            case ContainerStyle.LITTLE_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerLittleBanner);
                break;
            case ContainerStyle.MEDIUM_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerMediumBanner);
                break;
            case ContainerStyle.BACKDROP_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerBackdropBanner);
                break;
            case ContainerStyle.NO_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().noBanner);
                break;
            case ContainerStyle.TINY_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerTinyBlueBanner);
                break;
            case ContainerStyle.PROFILE_BANNER_FF_DOT144:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().profileBannerContainerDOT144);
                break;
            case ContainerStyle.MEDWORLD_PROFILE:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().medworldProfileBannerContainer);
                break;
            case ContainerStyle.SMALL_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerSmallBlueBanner);
                break;
            case ContainerStyle.DARK_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDarkBlueBanner);
                break;
        }
        return styleName;
    };
    var getBackgroundImage = function() {
        if (style === ContainerStyle.NO_BANNER) {
            return;
        }
        if (style === ContainerStyle.PROFILE_BANNER_FF_DOT144) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().profileBannerDOT144)
            });
        }
        if (style === ContainerStyle.MEDWORLD_PROFILE) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().medworldProfileBanner)
            });
        }
        if (style === ContainerStyle.DARK_BLUE_BANNER) {
            return null;
        }
        var styleName;
        switch(style){
            case ContainerStyle.BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImageBlueBanner);
                break;
            case ContainerStyle.BACKDROP_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImageBackdropBanner);
                break;
            case ContainerStyle.LITTLE_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImageLittleBanner);
                break;
            case ContainerStyle.MEDIUM_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImageMediumBanner);
                break;
            case ContainerStyle.TINY_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImageTinyBanner);
                break;
            case ContainerStyle.SMALL_BLUE_BANNER:
                styleName = (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgBannerSmallBanner);
                break;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: styleName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BackgroundBannerImage__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bgImage)
            })
        });
    };
    var onVisibilityChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(document.visibilityState === "visible" && !router.pathname.includes("/job"))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            checkSession()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onVisibilityChange() {
            return _ref.apply(this, arguments);
        };
    }();
    // In SSR useLayoutEffect is having an error at server side check
    // : https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
    if (true) {
        (0,react__WEBPACK_IMPORTED_MODULE_8__.useLayoutEffect)(function() {
            document.addEventListener("visibilitychange", onVisibilityChange);
            return function() {
                return document.removeEventListener("visibilitychange", onVisibilityChange);
            };
        }, []);
    }
    if (!isLoading && !user && (router === null || router === void 0 ? void 0 : router.pathname) && !router.pathname.includes("/job")) {
        router.push(_app_constants_path__WEBPACK_IMPORTED_MODULE_2__/* .PATH.LOGOUT */ .m.LOGOUT);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().outsideContainer),
        children: [
            getBackgroundImage(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: getClassName(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    maxWidth: size,
                    className: className,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: noFooterMargin ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_10___default().noFooterMargin) : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CookieConsentPrompt, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__/* .ProfileBanner */ .c, {})
        ]
    });
};


/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 17184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobCard_container__6A1E7","grade":"JobCard_grade__61CF0","title":"JobCard_title__jdBTC","jobShare":"JobCard_jobShare__XgOzr","bottomContainer":"JobCard_bottomContainer__5YkI_","highlighted":"JobCard_highlighted__c9Wzg"};

/***/ }),

/***/ 52533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outsideContainer":"style_outsideContainer__J0QRG","bgImageBlueBanner":"style_bgImageBlueBanner__tJjtS","profileBannerDOT144":"style_profileBannerDOT144___TOm5","medworldProfileBanner":"style_medworldProfileBanner__BGPFR","bgBannerSmallBanner":"style_bgBannerSmallBanner__uvQho","bgImageBackdropBanner":"style_bgImageBackdropBanner__bmiLs","bgImageTinyBanner":"style_bgImageTinyBanner__UoFoC","bgImageLittleBanner":"style_bgImageLittleBanner__nFOoT","bgImageMediumBanner":"style_bgImageMediumBanner__gwd07","bgImage":"style_bgImage__6KJyu","container":"style_container__UzgeV","containerTinyBlueBanner":"style_containerTinyBlueBanner__EpPvB","containerSmallBlueBanner":"style_containerSmallBlueBanner__CZQSp","profileBannerContainerDOT144":"style_profileBannerContainerDOT144__IybMT","medworldProfileBannerContainer":"style_medworldProfileBannerContainer__utg1a","containerLittleBanner":"style_containerLittleBanner__PZrZb","containerMediumBanner":"style_containerMediumBanner__ICd2W","containerBackdropBanner":"style_containerBackdropBanner__ocVGx","noBanner":"style_noBanner__xwj8f","containerDarkBlueBanner":"style_containerDarkBlueBanner__wZfwm","noFooterMargin":"style_noFooterMargin__lH4Ac"};

/***/ })

}]);